import { useTranslation } from "react-i18next";
import { Col, Container, Row } from "reactstrap"
import Tabs from "src/components/Common/UI/Tabs/Tabs"

const UnitConfigurationHeaders = () => {
  const { t } = useTranslation();

  const tabList = [
    {name: "Καταστήματα", path: "/configuration/unitconfiguration/establishments"},
    {name: "Διευθύνσεις", path: "/configuration/unitconfiguration/departments"},
    {name: "Μονάδες", path: "/configuration/unitconfiguration/units"},
    {name: "ΑΤΜ", path: "/configuration/unitconfiguration/atms"}, 
    {name: "Θυγατρικές", path: "/configuration/unitconfiguration/dcompanies"},   
  ]
  
  return (
    <Container fluid>
      <Row>
        <Col xs={12} className="mb-3">
          <span className="h1">{t("Διαχείριση Μονάδων")}</span>
        </Col>
        <Col xs={12}>
          <Tabs tabList={tabList} />
        </Col>
      </Row>
    </Container>
  )
}

export default UnitConfigurationHeaders;
